import React from "react";

const MarkSheetFormatOne = ({ marksheet }) => {
  const {
    report_info = {},
    done_subjects = [],
    marks_collection = {}
  } = marksheet || {};

  const { title, report_format = {} } = report_info;
  const formatId = Number(report_format.format_id);
  const studentInfo = marks_collection?.student_info || [];

  const SubjectHeadRow = ({ subject }) => (
    <>
      {subject?.done_papers?.map((paper, idx) => (
        <td key={idx}>{paper.paper_code}</td>
      ))}
      <td>{formatId === 2 ? "Id" : "GD"}</td>
    </>
  );

  const MarkCellGroup = ({ studentMarks = {}, donePapers = [], subjectId }) => {
    const totalMark = studentMarks.total_mark || {};
    const grade = studentMarks.advanced_grade || {};

    return (
      <>
        {donePapers.map((paper, idx) => {
          let display = "-";

          if (formatId === 2) {
            display = studentMarks.subject_average ?? "-";
          } else if (formatId === 5) {
            display = studentMarks.summative_plus_formative?.[subjectId] ?? "-";
          } else {
            display = totalMark[paper.paper_id] ?? "-";
          }

          return (
            <td key={idx} style={{ textAlign: "center" }}>
              {display}
            </td>
          );
        })}

        <td
          style={
            grade[subjectId]
              ? {
                  backgroundColor: "#000000",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  textAlign: "center"
                }
              : { textAlign: "center" }
          }
        >
          {grade[subjectId] || ""}
        </td>
      </>
    );
  };

  if (!Array.isArray(studentInfo)) return null;

  return (
    <table
      width="100%"
      border="1"
      className="Reports"
      style={{ fontSize: "12px" }}
      cellSpacing="0"
      cellPadding="0"
    >
      <caption>{title}</caption>
      <thead>
        <tr>
          <th>NO</th>
          <th>NAMES</th>
          {done_subjects.map((subject, idx) => (
            <th
              key={idx}
              colSpan={(subject.total_papers || 0) + 1}
              style={{ textAlign: "center" }}
            >
              {subject.subject_info?.abbreviation}
            </th>
          ))}
          <th style={{ textAlign: "center" }}>TOTAL</th>
          <th style={{ textAlign: "center" }}>AVG</th>
          <th style={{ textAlign: "center" }}>PSN</th>
        </tr>
      </thead>
      <tbody>
        {/* Header Row for paper codes */}
        <tr
          style={{
            backgroundColor: "#000000",
            color: "#FFFFFF",
            fontWeight: "bold",
            textAlign: "center"
          }}
        >
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          {done_subjects.map((subject, idx) => (
            <SubjectHeadRow key={idx} subject={subject} />
          ))}
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>

        {/* Student rows */}
        {studentInfo.map((student, idx) => {
          const studentId = student.id;
          const studentMarks = marks_collection?.[studentId] || {};

          return (
            <tr key={studentId}>
              <td>{idx + 1}</td>
              <td>{student.full_name}</td>

              {done_subjects.map((subject, key) => {
                const subjectId = subject.subject_info?.subject_id;
                return (
                  <MarkCellGroup
                    key={key}
                    studentMarks={studentMarks?.[subjectId]}
                    donePapers={subject.done_papers}
                    subjectId={subjectId}
                  />
                );
              })}

              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                {studentMarks.total}
              </td>
              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                {studentMarks.average}
              </td>
              <td style={{ textAlign: "center", fontWeight: "bold" }}>
                {studentMarks.position?.position}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default MarkSheetFormatOne;
